import { useTranslation } from "react-i18next";
import { ModalLayout } from "./ModalLayout";

interface DeactiveConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const DeactiveConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  
}: DeactiveConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onClose}
      title={t("products.deactivateConfirm.title")}
    >
      <div className="space-y-4">
        <p>{t("products.deactivateConfirm.message")}</p>
        <div className="flex justify-end gap-3">
          <button className="btn btn-ghost" onClick={onClose}>
            {t("common.cancel")}
          </button>
          <button
            className="btn btn-error"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {t("products.deactivateConfirm.confirm")}
          </button>
        </div>
      </div>
    </ModalLayout>
  );
}; 